/* eslint-disable @typescript-eslint/naming-convention */
import { useI18n } from '@udemy/i18n';
import classNames from 'classnames';
import React from 'react';
import styles from "./progress.module.css";
/** React Props interface for the Progress component */

/**
 * ### Progress
 *
 * An implementation of the HTML5 `<progress />` element.
 *
 * @remarks
 * We currently do not support an indeterminate state for the progress bar.
 * The `max` value must be set until then.  It is defaulted to `100`.
 */
export const Progress = _ref => {
  let {
    label,
    max = 100,
    value = 0,
    srOnlyLabel = true,
    rounded = false,
    colorScheme = 'purple',
    showPercentage = false,
    className,
    labelClassName
  } = _ref;
  const {
    interpolate,
    gettext
  } = useI18n();
  const purpleScheme = {
    '--progress-bar-background': 'var(--color-purple-150)',
    '--progress-bar-value': 'var(--color-purple-400)',
    '--progress-text-color': 'var(--color-purple-400)'
  };
  const greenScheme = {
    '--progress-bar-background': 'var(--color-green-150)',
    '--progress-bar-value': 'var(--color-green-300)',
    '--progress-text-color': 'var(--color-green-400)'
  };
  const colorStyles = colorScheme === 'blue' || colorScheme === 'purple' ? purpleScheme : greenScheme;
  return (
    /*#__PURE__*/

    /** .ud-progress-wrapper global selector is used by MinimalHeader */
    React.createElement("label", {
      style: colorStyles,
      className: classNames(styles.wrapper, 'ud-progress-wrapper', labelClassName)
    }, /*#__PURE__*/React.createElement("span", {
      className: srOnlyLabel ? 'ud-sr-only' : ''
    }, label), /*#__PURE__*/React.createElement("div", {
      className: styles['internal-wrapper']
    }, /*#__PURE__*/React.createElement("progress", {
      className: classNames(styles['ud-progress'], {
        [styles.rounded]: rounded
      }, className),
      value: value,
      max: max
    }, interpolate(gettext('%(value)s%'), {
      value
    }, true)), showPercentage && /*#__PURE__*/React.createElement("strong", {
      "aria-hidden": "true",
      className: "ud-heading-xs"
    }, interpolate(gettext('%(value)s%'), {
      value
    }, true))))
  );
};
//# sourceMappingURL=progress.react-component.js.map